import type { ImpactManagerInterface } from '@/typings/impact-manager';
import { getCookieRootDomain } from '@/utils/config';
import { getCookie, removeCookie } from '@/utils/cookies';
import { setTabAwareCookie } from './cookies';

export class ImpactManager implements ImpactManagerInterface {
  private readonly queryParamName: string = 'im_ref';
  private readonly imRefCookieName: string = 'impact_ref_id';

  setCookie() {
    const imRef = new URLSearchParams(window.location.search).get(this.queryParamName);

    if (imRef !== null) {
      const existingValue = getCookie(this.imRefCookieName);

      // New im_ref always wins - if different one exists, remove existing tracking first
      if (existingValue !== undefined && existingValue !== imRef) {
        this.removeCookie();
      }

      setTabAwareCookie(this.imRefCookieName, imRef);
    }
  }

  getCookie() : string | null {
    return getCookie(this.imRefCookieName) ?? null;
  }

  removeCookie() {
    const domain = getCookieRootDomain();
    const isSecure = window.location.protocol === 'https:';

    // Remove main cookie
    removeCookie(this.imRefCookieName, {
      domain,
      secure: isSecure,
      sameSite: 'lax'
    });

    // Remove tab tracking cookie
    removeCookie(`${this.imRefCookieName}_tabs`, {
      domain,
      secure: isSecure,
      sameSite: 'lax'
    });
  }
}

const impactManager = new ImpactManager();

impactManager.setCookie();

window.impactManager = impactManager;
